import {CSSProperties} from "react";

const MediumSquare = ({gradient, style}: {gradient?: boolean, style?: CSSProperties}) => {
    if (gradient) {
        return (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{...style}}>
                <path
                    d="M14.25 0.5H1.75C1.41848 0.5 1.10054 0.631696 0.866116 0.866116C0.631696 1.10054 0.5 1.41848 0.5 1.75V14.25C0.5 14.5815 0.631696 14.8995 0.866116 15.1339C1.10054 15.3683 1.41848 15.5 1.75 15.5H14.25C14.5815 15.5 14.8995 15.3683 15.1339 15.1339C15.3683 14.8995 15.5 14.5815 15.5 14.25V1.75C15.5 1.41848 15.3683 1.10054 15.1339 0.866116C14.8995 0.631696 14.5815 0.5 14.25 0.5ZM14.25 14.25H1.75V1.75H14.25V14.25Z"
                    fill="url(#paint0_linear_678_353)"/>
                <defs>
                    <linearGradient id="paint0_linear_678_353" x1="15.5" y1="0.5" x2="0.5" y2="0.5"
                                    gradientUnits="userSpaceOnUse">
                        <stop stop-color="#DB3B5C"/>
                        <stop offset="0.465749" stop-color="#8937A5"/>
                        <stop offset="1" stop-color="#455AC7"/>
                    </linearGradient>
                </defs>
            </svg>
        )
    } else {
        return (<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{...style}}>
            <path
                d="M16.75 2.5H4.25C3.91848 2.5 3.60054 2.6317 3.36612 2.86612C3.1317 3.10054 3 3.41848 3 3.75V16.25C3 16.5815 3.1317 16.8995 3.36612 17.1339C3.60054 17.3683 3.91848 17.5 4.25 17.5H16.75C17.0815 17.5 17.3995 17.3683 17.6339 17.1339C17.8683 16.8995 18 16.5815 18 16.25V3.75C18 3.41848 17.8683 3.10054 17.6339 2.86612C17.3995 2.6317 17.0815 2.5 16.75 2.5ZM16.75 16.25H4.25V3.75H16.75V16.25Z"
                fill="white"/>
        </svg>);
    }
};

export default MediumSquare;
